module.exports = "data:image/gif;base64,R0lGODlhCgAKAIAAAI2UmRcoOSH5BAAAAAAALAAAAAAKAAoAAAIUjI8By2v8nJJQJYsRiHv2CjbVdRQAOw=="